import { QueryCache, QueryClient } from '@tanstack/react-query';

import { logger } from '../../../core/Log/logger';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
        },
    },
    queryCache: new QueryCache({
        onError: (error) => {
            logger.error('React Query error', {}, error);
        },
    }),
});
